const side = [
  {
    name: '业务运营',
    url: '',
    index: '1',
    icon: 'iconfont icon-gongzuotai',
    decide: ['business'],
    children: [
      {
        name: '患者管理',
        url: 'hospaList',
        index: '1-1',
        icon: 'iconfont icon-huanzheguanli',
        decide: [
          'business-hospa',
        ],
      },
      {
        name: '我的患者',
        url: 'myhospaList',
        index: '1-7',
        icon: 'iconfont icon-huanzheguanli',
        decide: [
          'business-myhoslist',
        ],
      },
      {
        name: '样本管理',
        url: 'hospaSample',
        index: '1-2',
        icon: 'iconfont icon-yangbenpeizhi',
        decide: [
          'business-sample',
        ],
      },
      {
        name: 'AI识别任务',
        url: 'ocrList',
        index: '1-3',
        icon: 'iconfont icon-shibie',
        decide: [
          'business-ocr',
        ],
      },
      {
        name: '患者咨询',
        url: 'chatHistory',
        index: '1-4',
        icon: 'iconfont icon-liaotianjilu',
        decide: [
          'business-chathis',
        ],
      },
      {
        name: '群发消息',
        url: 'postMessage',
        index: '1-5',
        icon: 'iconfont icon-qunfaxiaoxi',
        decide: [
          'business-postmessage',
        ]
      },
      {
        name: '统计',
        url: 'statistics',
        index: '1-6',
        icon: 'iconfont icon-tongji',
        decide: [
          'business-statistics',
        ]
      },
      {
        name: '大屏',
        url: 'dataDashboard',
        index: '1-8',
        icon: 'iconfont icon-tongji',
        decide: [
          'business-datadashboard',
        ]
      },
    ]
  },
  {
    name: '平台配置',
    url: '',
    index: '2',
    icon: 'iconfont icon-peizhiguanli',
    decide: ['platform'],
    children: [
      {
        name: '减重方案',
        url: '',
        index: '2-1',
        icon: 'iconfont icon-shezhiicon_weixuanzhongtai',
        decide: [
          'platform-lessweight',
        ],
      },
      {
        name: '饮食知识库',
        url: '',
        index: '2-2',
        icon: 'iconfont icon-yinshi',
        decide: [
          'platform-foodknowledge',
        ],
      },
      {
        name: '运动知识库',
        url: '',
        index: '2-3',
        icon: 'iconfont icon-run-line',
        decide: [
          'platform-sportknowledge',
        ],
      },
      {
        name: '随访配置',
        url: 'follow',
        index: '2-4',
        icon: 'iconfont icon-suifang',
        decide: [
          'platform-follow',
        ],
      },
      {
        name: '客服配置',
        url: 'serviceView',
        index: '2-5',
        icon: 'iconfont icon-kefu',
        decide: [
          'platform-customer',
          'platform-cquestions',
          'platform-schedule',
        ],
      },
      {
        name: '表单配置',
        url: 'surveyView',
        index: '2-6',
        icon: 'iconfont icon-wenjuan',
        decide: [
          'platform-survey',
          'platform-madsurvey',
          'platform-mensurvey'
        ],
      },
      {
        name: '表单管理',
        url: 'squesView',
        index: '2-8',
        icon: 'iconfont icon-filetexto',
        decide: [
          'platform-sques',
        ],
      },
      {
        name: '文章配置',
        url: 'articleView',
        index: '2-7',
        icon: 'iconfont icon-wodewenzhang',
        decide: [
          'platform-article',
        ],
      },
    ]
  },
  {
    name: '运维管理',
    url: '',
    index: '3',
    icon: 'iconfont icon-yunwei',
    decide: ['setting'],
    children: [
      {
        name: '系统用户',
        url: 'userSetting',
        index: '3-1',
        icon: 'iconfont icon-yonghu',
        decide: [
          'setting-user',
          'setting-role',
        ],
      },
      {
        name: '机构管理',
        url: 'medicalView',
        index: '3-2',
        icon: 'iconfont icon-yiliaojigou',
        decide: [
          'setting-medical',
        ],
      },
      {
        name: '登记处',
        url: 'applyView',
        icon: 'iconfont icon-fenghuangxiangmutubiao_dengjichu',
        index: '3-3',
        decide: [
          'setting-apply',
        ],
      },
      {
        name: 'hash工具',
        url: 'hash',
        icon: 'iconfont icon-yewubianma',
        index: '3-4',
        decide: [
          'setting-hash',
        ],
      },
      {
        name: '字典配置',
        url: 'dictionaries',
        icon: 'iconfont icon-shujuzidianpeizhi',
        index: '3-5',
        decide: [
          'setting-dictionaries',
        ],
      },
      {
        name: '页面配置',
        url: 'pagetableView',
        icon: 'iconfont icon-biaotoushezhi_huabanfuben',
        index: '3-6',
        decide: [
          'setting-pagetable',
        ],
      },
      {
        name: '日志管理',
        url: 'ulog',
        index: '3-7',
        icon: 'iconfont icon-25shishirizhi',
        decide: [
          'setting-ulog',
        ],
      },
      {
        name: '药品管理',
        url: 'medication',
        index: '3-8',
        icon: 'iconfont icon-orally',
        decide: [
          'setting-medication',
        ],
      },
      {
        name: '工具下载',
        url: 'tools',
        icon: 'iconfont icon-icongongju',
        index: '3-9',
        decide: [
          'setting-tools',
        ],
      },
      {
        name: '课题配置',
        url: 'issueView',
        icon: 'iconfont icon-biaotoushezhi_huabanfuben',
        index: '3-10',
        decide: [
          'setting-issue',
        ],
      },
      {
        name: '导出配置',
        url: 'exportConfig',
        icon: 'iconfont icon-biaotoushezhi_huabanfuben',
        index: '3-11',
        decide: [
          'setting-export',
        ],
      },
    ]
  },
];
export default side